import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { FINANCIAL_API } from "./apiRoutes";

const mutateAddFinancialReporting = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(`${FINANCIAL_API}/`, data);
};

const useAddFinancialReportingMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddFinancialReporting,
    ...queryParams,
  });

export default useAddFinancialReportingMutation;
